import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import MapContainer2 from "./Map2";
import mqtt from "mqtt";


function Dashboard() {
  const [dataArr, setDataArr] = useState([]);
  const [totalDevices, setTotalDevices] = useState(0);

  useEffect(() => {
    fetch(`https://api.db2sg.com/esps`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response?.status} ${response?.statusText}`
          );
        }
        return response.json();
      })
      .then((result) => {
        console.log(result, "result?.data");

        if (result) {
          fetch(`https://db2sg.com/HamitaherApi/user.php`, {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error(
                  `HTTP error! Status: ${response?.status} ${response?.statusText}`
                );
              }

              return response.json();
            })
            .then((res) => {
              const updatedData = result?.data?.map((device) => {
                const userWithDevice = res.find((user) => {
                  const deviceData =
                    user?.devices && (user?.devices)[device.id];
                  console.log("Found device data:", deviceData); // Debugging line
                  return deviceData;
                });

                return {
                  ...device,
                  user: userWithDevice ? userWithDevice.name : "Unknown",
                  deviceInfo: userWithDevice ? { ...userWithDevice } : null, // Store device info
                };
              });

              setDataArr(updatedData);

              console.log(updatedData, "Updated data with user info");
            })
            .catch((error) => {
              console.log(error, "Error");
            });
        }
      })
      .catch((error) => console.log(error));
  }, []);
  const navigate = useNavigate();
  const [userCounts, setUserCounts] = useState({
    totalUsers: 0,
    technicians: 0,
    admins: 0,
    users: 0,
    sitemanager: 0,
    totalDevice:0,
  });
  const [devices, setDevices] = useState("0");

  // eslint-disable-next-line
  const [onlineDevices, setOnlineDevices] = useState({});
  
  useEffect(() => {
    const client = mqtt.connect("wss://mqtt.db2sg.com:9001/mqtt");
  
    client.on("connect", () => {
      console.log("MQTT connected");
      client.subscribe("#");
    });
  
    client.on("message", (topic, message) => {
      if (!topic.includes("heartbeat")) return;
  
      const deviceId = topic.split("/")[0];
  
      setOnlineDevices((prev) => {
        const updated = {
          ...prev,
          [deviceId]: message?.toString(),
        };
        const currentTime =
        new Date().getTime() + new Date().getTimezoneOffset() * 60000;

      const onlineDevices = Object.values(updated).filter((user) => {
      // console.log(user,"7777")
        if(user?.length < 3) return false; 

        const date = parseTimestamp(user); // Use user.heartbeat, not result.heartbeat
        if (isNaN(date.getTime())) return false;
        const lastHeartbeat = date.getTime();
        const timeDifference = (currentTime - lastHeartbeat) / 1000; // in seconds
        return timeDifference <= 10; // online if last heartbeat within 10 seconds
      });

        setDevices(onlineDevices.length);
  
        return updated;
      });
      setDataArr((prevDevices) =>
  prevDevices.map((dev) =>
    dev.id === deviceId
      ? { ...dev, heartbeat: message.toString() } // update heartbeat
      : dev
  )
);

    });
  
    return () => client.end();
    
  }, []);
  

    
  //////////////get all users///////////////

  function parseTimestamp(timestamp) {
    try {
      const [datePart, timePart] = timestamp.split(" ");
      const [day, month, year] = datePart.split("/").map(Number);
      const [hour, minute, second] = timePart.split(":").map(Number);
  
      return new Date(year, month - 1, day, hour, minute, second);
    } catch (e) {
      // console.log(e);
      return new Date();
    }
  }
  useEffect(() => {
    fetch(`https://db2sg.com/HamitaherApi/user.php`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(
            `HTTP error! Status: ${response?.status} ${response?.statusText}`
          );
        }
        return response.json();
      })
      .then((result) => {
        if (result && Array.isArray(result)) {
          const totalUsers = result.length;
          const technicians = result.filter(
            (user) => user.userType === "technician"
          ).length;
          const sitemanager = result.filter(
            (user) => user.userType === "sitemanager"
          ).length;
          const admins = result.filter(
            (user) => user.userType === "admin"
          ).length;
          const users = result.filter(
            (user) => user.userType === "user"
          ).length;
          setUserCounts({
            totalUsers,
            technicians,
            admins,
            users,
            sitemanager,
          });
          const totalProvisionedDevices = result.reduce((count, user) => {
        
            return (
              count +
              Object.values((user?.devices) || {}).filter(
                (device) => device.provisioned
              ).length
            );
          }, 0);
          setTotalDevices(totalProvisionedDevices)
          console.log(totalProvisionedDevices, "#################");
          // setDevices(totalProvisionedDevices);
        }
      })
      .catch((error) => console.log("Error fetching users:", error));

      fetch(`https://api.db2sg.com/esps`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `HTTP error! Status: ${response.status} ${response.statusText}`
            );
          }
          return response.json();
        })
        .then((result) => {
          if (result.data && Array.isArray(result.data)) {
            console.log(result.data)
            const currentTime =
              new Date().getTime() + new Date().getTimezoneOffset() * 60000;
      
            const onlineDevices = result.data.filter((user) => {
              if (!user.heartbeat) return false; // 🔒 Reject empty/null/undefined

            
              const date = parseTimestamp(user.heartbeat); // Use user.heartbeat, not result.heartbeat
              if (isNaN(date.getTime())) return false;
              const lastHeartbeat = date.getTime();
              const timeDifference = (currentTime - lastHeartbeat) / 1000; // in seconds
              return timeDifference <= 10; // online if last heartbeat within 10 seconds
            });
           // setDevices(onlineDevices.length);

            console.log("Online Devices:", onlineDevices.length);
          }
        })
        .catch((error) => console.log("Error fetching users:", error));
      
  }, []);

  const cards = [
    // {
    //   title: "Admins",
    //   type: "admin",
    //   count: userCounts.admins,
    //   color: "#8ec0fc",
    //   route: "/management",
    // },
    {
      title: "Site Manager",
      type: "sitemanager",
      count: userCounts.sitemanager,
      color: "#8ec0fc",
      route: "/management",
    },
    {
      title: "Technicians",
      type: "technician",
      count: userCounts.technicians,
      color: "#8ec0fc",
      route: "/management",
    },

    {
      title: "Users",
      type: "user",
      count: userCounts.users,
      color: "#8ec0fc",
      route: "/management",
    },

    {
      title: "Online Devices",
      type: "device",
      count: devices,
      color: "#8ec0fc",
      route: "/devices",
    },
    {
      title: "Total Devices",
      type: "totaldevice",
      count: totalDevices,
      color: "#8ec0fc",
      route: "/devices"
    },
  ];
  const { t } = useTranslation();

  return (
    <div
      style={{
        padding: "30px",
        minHeight: "87vh",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "2fr 1fr",   // Map Left, Cards Right
          gap: "30px",
          width: "100%",
          maxWidth: "1400px",
        }}
      >
        {/* ---------------- LEFT SIDE: MAP ---------------- */}
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "15px",
            boxShadow: "0px 5px 15px rgba(0,0,0,0.1)",
            height: "650px",
          }}
        >
        
          <MapContainer2
          devices={dataArr.filter((d) => d.latitude && d.longitude)}
          maxHeight="600px"
            maxWidth="100%"
          />
        </div>
  
        {/* ---------------- RIGHT SIDE: CARDS COLUMN ---------------- */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "15px",
          }}
        >
          {cards
            .filter((card) =>
              localStorage.getItem("usertype") === "technician"
                ? card?.type === "user" || card?.type === "device"||card?.type === "totaldevice" 
                : localStorage.getItem("usertype") === "sitemanager"
                ? card?.type === "user" ||
                  card?.type === "technician" ||
                   card?.type === "totaldevice" ||
                  card?.type === "device"
                : true
            )
            .map((card, index) => (
              <div
                key={index}
                onClick={() =>
                  navigate(card.route, { state: { role: card.type } })
                }
                style={{
                  background: "white",
                  borderLeft: `8px solid ${card.color}`,
                  color: "#333",
                  padding: "20px",
                  borderRadius: "12px",
                  boxShadow: "0px 5px 15px rgba(0,0,0,0.1)",
                  cursor: "pointer",
                  transition: "0.3s",
                  textAlign: "center",
                  border:"2px solid #000",
                  paddingBottom:"5px"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "scale(1)";
                }}
              >
                <h3 style={{ margin: 0, color: "#8ec0fc" }}>
                  {t(card.title)}
                </h3>
  
                <p
                  style={{
                    fontSize: "180%",
                    fontWeight: "bold",
                    marginTop: "10px",
                    background:
                      "linear-gradient(45deg, #000, #000, #000, #000)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  {card.count}
                </p>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
  
}

export default Dashboard;
